import { render, staticRenderFns } from "./PS.vue?vue&type=template&id=343405f4&scoped=true"
import script from "./PS.vue?vue&type=script&lang=js"
export * from "./PS.vue?vue&type=script&lang=js"
import style0 from "./PS.vue?vue&type=style&index=0&id=343405f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343405f4",
  null
  
)

export default component.exports